import { BallType } from "./game";

export default class ObjectiveBallInfo {

    public static getBallType(objectiveIndex: number, ballsDelivered: number, currentOver?: number): BallType {
        let ballsPerOver = 6;

        switch (objectiveIndex) {
            case -1:
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered < 6) {
                        return BallType.Slow;
                    }
                    else if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {

                        var items = [BallType.Medium, BallType.OffSpin, BallType.LegSpin];
                        return items[Math.floor(Math.random() * items.length)];
                    } else {

                        var items = [BallType.Fast, BallType.OffSpin, BallType.LegSpin];
                        return items[Math.floor(Math.random() * items.length)];
                    }


                }
                break;
            case 0:
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Slow;
                }
                break;

            case 1:
                //objectiveMessage = 'Chase 15 Runs';
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Slow;
                }
                break;

            case 2:
                //objectiveMessage = 'How many boundaries in 3 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 3:
                //objectiveMessage = 'Highest score in 3 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 4:
                //objectiveMessage = 'Last an over without missing a ball';
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Slow;
                }
                break;

            case 5:
                //objectiveMessage = 'Score 20 runs in 3 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 6:
                //objectiveMessage = 'Score as many 6s in 4 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 7:
                //objectiveMessage = 'Score as many consecutive boundaries';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 8:
                //objectiveMessage = 'Last 60 seconds without getting out';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 9:
                //objectiveMessage = 'Score 50 runs in 7 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 24) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }

                break;

            case 10:
                //objectiveMessage = 'Play till you miss a ball or get out';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 11:
                //objectiveMessage = 'Try to hit more than 6 sixes in 3 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 12:
                // if 0 it means losing
                //objectiveMessage = 'Two overs to score as many runs as possible';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 6) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 13:
                // if 0 it means losing
                //objectiveMessage = 'Hit as many boundaries you can in 2 overs';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 6) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 14:
                // 0 is losing
                //objectiveMessage = 'Score as many 6s as possible in 2 overs'
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 6) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 15:
                //objectiveMessage = 'Chase 30 runs in 3 overs without losing more than 3 wickets';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 16:
                //objectiveMessage = 'Score as many boundaries as possible in 3 overs without losing more than 3 wickets'
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 17:
                //objectiveMessage = 'Highest score in 3 overs without losing more than 3 wickets';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 18:
                //objectiveMessage = 'Last 2 overs in the net without missing a ball.';
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Medium;
                }
                break;

            case 19:
                //objectiveMessage = 'Score 20 runs in 3 overs without losing more than 3 wickets.';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.OffSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 20:
                // If 0 you lose
                //objectiveMessage = 'Score as many 6s in 3 overs without losing more than 3 wickets';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 21:
                //objectiveMessage = 'Score as many consecutive boundaries within 3 overs without losing more than 3 wickets.'
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.OffSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 22:
                //objectiveMessage = 'Last 90 seconds without losing a wicket';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 23:
                //objectiveMessage = 'Score 60 runs in 5 overs without losing more than 3 wickets';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 24:
                //
                // If 0 you lose
                //objectiveMessage = 'Score as many 6s in 3 overs without losing more than 2 wickets';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Medium;
                }
                break;

            case 25:
                //Last 120 seconds without losing a wicket or missing a ball
                //objectiveMessage = 'Last 120 seconds without losing a wicket or missing a ball';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Fast;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Fast;
                }
                break;

            case 26:
                //Last 3 overs without losing a wicket.
                //objectiveMessage = 'Last 3 overs without losing a wicket.';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Fast;
                }
                break;

            case 27:
                //Score 30 runs from 3 overs without losing more than 2 wicket
                //objectiveMessage = 'Score 30 runs from 3 overs without losing more than 2 wicket';
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Fast;
                }
                break;

            case 28:
                //Score as many boundaries as possible from 2 overs without losing more than 2 wicket
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.LegSpin;
                    }
                    return BallType.OffSpin;
                }
                break;

            case 29:
                //Score as many 6s in a row as possible within 3 overs without losing more than 2 wickets.
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.OffSpin;
                    } else if (ballsDelivered == 12) {
                        return BallType.LegSpin;
                    }
                    return BallType.Fast;
                }
                break;
            case 30:
                // Score 75 runs in 5 overs while not losing more than 3 wickets
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 18) {
                        return BallType.Fast;
                    } else if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 31:
                // Score 30 runs without losing a wicket
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Medium;
                }
                break;

            case 32:
                // Hit 5 sixes in a row
                return BallType.Slow;

            case 33:
                // Hit 5 boundaries in a row
                return BallType.Medium;

            case 34:
                // Score 20 runs in 1 over
                return BallType.Medium;

            case 35:
                // Score 50 runs in 10 balls
                if (ballsDelivered % 2 == 0) {
                    return BallType.Slow;
                } else {
                    return BallType.Medium;
                }

            case 36:
                // Score 50 runs without losing a wicket
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 12) {
                        return BallType.Fast;
                    }
                    return BallType.Medium;
                }
                break;

            case 37:
                // Score 50 runs without missing a single ball
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 18) {
                        return BallType.Fast;
                    } else if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 38:
                // Score 10 runs in 2 balls
                return BallType.Slow;

            case 39:
                // Last 2 overs without losing a wicket or missing a ball
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Fast;
                }
                break;

            case 40:
                // Hit boundaries or sixes on 3 consecutive spin balls
                return BallType.OffSpin;

            case 41:
                // Score 25 runs off a spin bowler without losing a wicket
                return BallType.LegSpin;

            case 42:
                // Score 100 runs in 3 overs
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Slow;
                }
                break;

            case 43:
                // Last 4 overs without losing a wicket
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.Fast;
                    } else if (ballsDelivered == 18) {
                        return BallType.OffSpin;
                    }
                    return BallType.LegSpin;
                }
                break;

            case 44:
                // Score 70 runs in 2 overs
                if (ballsDelivered % ballsPerOver == 0) {
                    return BallType.Slow;
                }
                break;

            case 45:
                // Score 100 runs without losing a wicket
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered >= 18) {
                        return BallType.Fast;
                    } else if (ballsDelivered >= 12) {
                        return BallType.Medium;
                    }
                    return BallType.Slow;
                }
                break;

            case 46:
                // Score 30 runs in 1 over
                return BallType.Medium;

            case 47:
                // Hit boundaries or sixes on 6 consecutive spin balls
                return BallType.OffSpin;

            case 48:
                // Last 3 overs without losing a wicket or a ball
                if (ballsDelivered % ballsPerOver == 0) {
                    if (ballsDelivered == 6) {
                        return BallType.Medium;
                    } else if (ballsDelivered == 12) {
                        return BallType.Fast;
                    }
                    return BallType.OffSpin;
                }
                break;

            case 49:
                // Score 12 runs in 2 balls
                return BallType.Slow;
        }

        return Math.floor(Math.random() * 4);
    }
}